// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/booking/stylesheet/style.scss
 ** module id = 400
 ** module chunks = 1
 **/